import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=42353d5c&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42353d5c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42353d5c')) {
      api.createRecord('42353d5c', component.options)
    } else {
      api.reload('42353d5c', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=42353d5c&scoped=true&", function () {
      api.rerender('42353d5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2i0xIzz3NwcEw/JS/comp/SearchFilterTokens.vue"
export default component.exports